/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Review_LastInputs */

const cs_gdpr_review_last = /** @type {(inputs: Gdpr_Review_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední aktivita`)
};

const en_gdpr_review_last = /** @type {(inputs: Gdpr_Review_LastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last activity`)
};

/**
* | output |
* | --- |
* | "Last activity" |
*
* @param {Gdpr_Review_LastInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_review_last = /** @type {((inputs?: Gdpr_Review_LastInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Review_LastInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_review_last(inputs)
	return cs_gdpr_review_last(inputs)
});